import { PERCENTAGE_ACTION_TYPES } from '../../actions/percentage/percentage_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const percentages = (state = initialState, action) => {
    switch (action.type) {
        case PERCENTAGE_ACTION_TYPES.GET_PERCENTAGES_SUCCESS:
            return { ...state, collection: action.payload };
        case PERCENTAGE_ACTION_TYPES.POST_PERCENTAGE_URL:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case PERCENTAGE_ACTION_TYPES.PUT_PERCENTAGE_SUCCESS:
            const updatedPercentage = action.payload;
            return { ...state, collection: state.collection.map((percentage) => percentage.uuid !== updatedPercentage.uuid ? percentage : { ...percentage, ...updatedPercentage }) };
        case PERCENTAGE_ACTION_TYPES.UPDATE_PERCENTAGES_URL:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
